"use client";
import { FormInstance } from "antd";
import { Dispatch, useRef } from "react";

export const useDataListRef = () => {
  const fieldChange = useRef<Record<string, Function>>({});
  const form = useRef<FormInstance<any>>(undefined);
  const formMemo = useRef<Record<string, any>>({});
  const formFunction = useRef<Record<string, Record<string, Function>>>({});
  const dataFunction = useRef<Record<string, Function>>({});
  const setValueList = useRef<Record<string, Function>>({});
  const setSubData = useRef<(target: string, data: any) => void | undefined>(undefined);
  const initFunction = useRef<Function[] | undefined>([]);
  const setFormFunction = (obj: FormInstance<any>) => {
    form.current = obj;
  };
  const setSubDataFunction = (obj: (target: string, data: any) => void) => {
    setSubData.current = obj;
  };
  return { form, setFormFunction, fieldChange, formMemo, formFunction, setValueList, dataFunction, initFunction, setSubDataFunction };
};
